import { buildIconCircleStyle } from "./IconCircle.styles";

export const IconCircle = ({ src, alt, size = 120 }) => (
  <div style={buildIconCircleStyle(size)}>
    <img src={src} alt={alt} width={size} height={size} />
  </div>
);

export default IconCircle;